// ✅ NUEVO: Enums separados para ownership y usage
export enum VehicleOwnership {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}

export enum VehicleUsage {
  CONSTRUCTION = 'CONSTRUCTION',
  ACCIDENT = 'ACCIDENT',
}

// Labels para ownership
export const VehicleOwnershipLabels = {
  [VehicleOwnership.INTERNAL]: {
    ca: 'Intern',
    es: 'Intern',
    en: 'Internal',
  },
  [VehicleOwnership.EXTERNAL]: {
    ca: 'Extern',
    es: 'Extern',
    en: 'External',
  },
};

// Labels para usage
export const VehicleUsageLabels = {
  [VehicleUsage.CONSTRUCTION]: {
    ca: 'Obra',
    es: 'Obra',
    en: 'Construction',
  },
  [VehicleUsage.ACCIDENT]: {
    ca: 'Accident',
    es: 'Accidente',
    en: 'Accident',
  },
};

// Helper functions para nuevos enums
export const getVehicleOwnershipLabel = (
  ownership: VehicleOwnership | string | undefined,
  language: 'ca' | 'es' | 'en' = 'es'
): string => {
  // Validación defensiva para evitar errores con datos undefined o inválidos
  if (!ownership || !(ownership in VehicleOwnershipLabels)) {
    console.warn(`Invalid ownership value: ${ownership}, defaulting to INTERNAL`);
    return VehicleOwnershipLabels[VehicleOwnership.INTERNAL][language];
  }
  return VehicleOwnershipLabels[ownership as VehicleOwnership][language];
};

export const getVehicleUsageLabel = (
  usage: VehicleUsage | string | undefined,
  language: 'ca' | 'es' | 'en' = 'es'
): string => {
  // Validación defensiva para evitar errores con datos undefined o inválidos
  if (!usage || !(usage in VehicleUsageLabels)) {
    console.warn(`Invalid usage value: ${usage}, defaulting to CONSTRUCTION`);
    return VehicleUsageLabels[VehicleUsage.CONSTRUCTION][language];
  }
  return VehicleUsageLabels[usage as VehicleUsage][language];
};

// Opciones para dropdowns
export const VehicleOwnershipOptions = [
  { label: 'Intern', value: VehicleOwnership.INTERNAL },
  { label: 'Extern', value: VehicleOwnership.EXTERNAL },
];

export const VehicleUsageOptions = [
  { label: 'Obra', value: VehicleUsage.CONSTRUCTION },
  { label: 'Accidente', value: VehicleUsage.ACCIDENT },
];
